import { render, staticRenderFns } from "./LsInputLabel.vue?vue&type=template&id=6f9ea28d&scoped=true&"
import script from "./LsInputLabel.vue?vue&type=script&lang=js&"
export * from "./LsInputLabel.vue?vue&type=script&lang=js&"
import style0 from "./LsInputLabel.vue?vue&type=style&index=0&id=6f9ea28d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f9ea28d",
  null
  
)

export default component.exports